"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.datePickerLocalePropTypes = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var datePickerLocalePropTypes = _propTypes.default.shape({
  lang: _propTypes.default.shape({
    locale: _propTypes.default.string,
    placeholder: _propTypes.default.string,
    rangePlaceholder: _propTypes.default.arrayOf(_propTypes.default.string),
    today: _propTypes.default.string,
    now: _propTypes.default.string,
    backToToday: _propTypes.default.string,
    ok: _propTypes.default.string,
    clear: _propTypes.default.string,
    month: _propTypes.default.string,
    year: _propTypes.default.string,
    timeSelect: _propTypes.default.string,
    dateSelect: _propTypes.default.string,
    monthSelect: _propTypes.default.string,
    yearSelect: _propTypes.default.string,
    decadeSelect: _propTypes.default.string,
    yearFormat: _propTypes.default.string,
    dateFormat: _propTypes.default.string,
    dayFormat: _propTypes.default.string,
    dateTimeFormat: _propTypes.default.string,
    monthFormat: _propTypes.default.string,
    monthBeforeYear: _propTypes.default.bool,
    previousMonth: _propTypes.default.string,
    nextMonth: _propTypes.default.string,
    previousYear: _propTypes.default.string,
    nextYear: _propTypes.default.string,
    previousDecade: _propTypes.default.string,
    nextDecade: _propTypes.default.string,
    previousCentury: _propTypes.default.string,
    nextCentury: _propTypes.default.string
  }),
  timePickerLocale: _propTypes.default.shape({
    placeholder: _propTypes.default.string
  }),
  dateFormat: _propTypes.default.string,
  dateTimeFormat: _propTypes.default.string,
  weekFormat: _propTypes.default.string,
  monthFormat: _propTypes.default.string
});

exports.datePickerLocalePropTypes = datePickerLocalePropTypes;